<template>
<div class="folders">
  <div class="folders__category">
    <div v-for="(folder, index) in folderCategory" :key="index" class="folder-category">
      <div class="folders__header" @click="toggleCategory(index)">
        <div class="icon-wrapper">
          <div class="icon" :class="{ 'open': isOpen[index] }">
            <div class="icon-line horizontal"></div>
            <div class="icon-line vertical"></div>
          </div>
        </div>
        <p>{{folder.title}}</p>
      </div>
      
      <div class="collapse-container" :style="{ height: isOpen[index] ? contentHeights[index] + 'px' : '0' }">
        <div class="collapse-content" :ref="el => contentRefs[index] = el">
          <NestedFolders :folders="folder.list"/>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import NestedFolders from '@/components/Nested/nestedFolders.vue'

export default {
  props: {
    folderCategory: {
      type: Array,
      default: () => ([])
    }
  },
  components: {
    NestedFolders
  },
  data() {
    return {
      isOpen: [],
      contentHeights: [],
      contentRefs: []
    }
  },
  watch: {
    folderCategory: {
      immediate: true,
      handler(newVal) {
        if (Array.isArray(newVal)) {
          this.isOpen = newVal.map(() => false)
          this.contentHeights = newVal.map(() => 0)
          this.contentRefs = new Array(newVal.length)
        }
      }
    }
  },
  mounted() {
    this.updateContentHeights()
  },
  updated() {
    this.updateContentHeights()
  },
  methods: {
    toggleCategory(index) {
      const newState = [...this.isOpen]
      newState[index] = !newState[index]
      this.isOpen = newState
      
      this.$nextTick(() => {
        this.updateContentHeights()
      })
    },
    updateContentHeights() {
      this.contentRefs.forEach((el, index) => {
        if (el && this.isOpen[index]) {
          this.contentHeights[index] = el.scrollHeight
        }
      })
    }
  }
}
</script>

<style scoped>
/* ===== Базовые размеры ===== */
/* 1rem = 16px */
/* 0.625rem = 10px */
/* 0.75rem = 12px */
/* 1rem = 16px */
/* 1.25rem = 20px */
/* 1.5rem = 24px */
/* 2rem = 32px */

/* Анимация иконки плюс/минус */
.icon-wrapper {
  width: 1.25rem; /* 20px */
  height: 1.25rem; /* 20px */
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon {
  position: relative;
  width: 1rem; /* 16px */
  height: 1rem; /* 16px */
  transition: transform 0.3s ease;
}

.icon.open {
  transform: rotate(180deg);
}

.icon-line {
  position: absolute;
  background-color: currentColor;
  border-radius: 0.125rem; /* 2px */
  transition: all 0.3s cubic-bezier(0.68, -0.55, 0.27, 1.55);
}

.horizontal {
  top: 50%;
  left: 0;
  width: 100%;
  height: 0.125rem; /* 2px */
  transform: translateY(-50%);
}

.vertical {
  top: 0;
  left: 50%;
  width: 0.125rem; /* 2px */
  height: 100%;
  transform: translateX(-50%);
}

.icon.open .vertical {
  height: 0;
  transform: translateX(-50%) scaleY(0.5);
}

/* Анимация раскрытия контента */
.collapse-container {
  transition: height 0.4s cubic-bezier(0.33, 1, 0.68, 1);
  overflow: hidden;
  will-change: height;
}

.collapse-content {
  padding-left: 1.5rem; /* 24px */
}

/* Остальные стили */
.folders__header {
  display: flex;
  gap: 0.75rem; /* 12px */
  cursor: pointer;
  align-items: center;
  user-select: none;
  padding: 0.625rem 0; /* 10px */
  transition: background-color 0.2s;
}

.folders__header:hover {
  background-color: rgba(0, 0, 0, 0.03);
}

.folders__category {
	border-top: 0.2rem solid var(--grey-1);
  overflow: scroll;
  height: 100%;
}

.folders {
  height: 100%;
  overflow: hidden;
  padding-bottom: 5rem;
}

.folders__container {
  overflow-y: scroll;
  display: flex;
  flex-wrap: nowrap;
  gap: 1rem;
  flex-direction: column;
  height: 100%;
  padding-bottom: 0.5rem;
  cursor: grab;
}

.folders__container::-webkit-scrollbar {
  width: 0;
}

::-webkit-scrollbar {
  width: 0;
}

.folders__item {
  border-radius: 0.5rem;
  overflow: hidden;
  position: relative;
  height: fit-content;
  min-height: calc(12vw + 2rem);
  margin-top: 0.5rem;
  border-radius: 0.5rem;
}

</style>